import { withStyles } from '@material-ui/core';

import LocationBlock from './component';
import styles from './styles';

export default withStyles(styles)(LocationBlock);
